<div
  id="errorpage"
  class="errorpage">
  <div class="errorpage-logo-container">
    <img
      src="assets/allianz-logo.png"
      alt="allianz-logo"
      class="errorpage-logo-img" />
  </div>
  <div class="errorpage-content">
    <img
      src="../../assets/warn.svg"
      alt="assets/warn.svg"
      class="errorpage-warning-img" />
    <div class="errorpage-headline">{{ "errorpage.headline" | text }}</div>
    <div class="errorpage-msg">{{ "errorpage.message" | text }}</div>
    <div
      class="errorpage-msg-bold"
      data-cy="einstieg-main-message">
      @if (errorpageTextIds$ | async) {
        @if (isArray(errorpageTextIds$ | async)) {
          <div>
            <ul>
              @for (textId of errorpageTextIds$ | async; track textId) {
                <li [innerHTML]="'errorpage.errorText.' + textId | html: (errorPageParams$ | async)"></li>
              }
            </ul>
          </div>
        } @else {
          @if (errorpageTextIds$ | async) {
            <span [innerHTML]="'errorpage.errorText.' + (errorpageTextIds$ | async) | html: (errorPageParams$ | async)">
            </span>
          } @else {
            <span>{{ "errorpage.errorText.default" | text }}</span>
          }
        }
        <br /><br />
        @if (errorPageZusatzTexte$ | async) {
          <div data-cy="einstieg-zusatz-message">
            <ul>
              @for (text of errorPageZusatzTexte$ | async; track text) {
                <li>
                  {{ text }}
                </li>
              }
            </ul>
          </div>
        }
      } @else {
        <span>{{ "errorpage.errorText.default" | text }}</span>
      }
    </div>
    <div class="errorpage-msg">{{ "errorpage.correlationId" | text }}</div>
    <div class="errorpage-msg-bold">{{ correlationId | async }}</div>
  </div>
</div>
